import { createContext, useContext, useState, ReactNode } from 'react';

export const translations: Record<string, Record<string, string>> = {
  ko: {
    // Header & HUD
    secureProtocol: '보안 프로토콜 활성화됨',
    sysOnline: '시스템 온라인',
    
    // Tabs
    tabBase: '작전실',
    tabCombat: '전투력',
    tabUnion: '소속',
    
    // Hero
    level: '레벨',
    todayWorkout: '오늘의 운동',
    streakDays: '연속 운동일',
    questCompleted: '완료한 퀘스트',
    sets: '세트',
    days: '일',
    
    // Onboarding / Tutorial
    tutorialTitle: '초보자 가이드 퀘스트 (튜토리얼)',
    tutorialSubtitle: '기본 훈련 프로토콜',
    onboardingDesc: '지옥 훈련소에 오신 것을 환영합니다! 신입 대원을 위한 간단한 퀘스트를 완수하여 작전실의 모든 보안 잠금을 해제하고, 진정한 성장을 시작하세요.',
    missionComplete: '작전 완수',
    tutorialStep1Title: '첫 번째 운동 세트 기록하기',
    tutorialStep1Desc: '하단 플로팅 바의 [+] 버튼을 탭하고 실제 수행한 운동을 기록해봅니다.',
    tutorialStep2Title: '전투력 가이드 확인하기',
    tutorialStep2Desc: '설정 내의 등급 시스템 메뉴를 통해 등급 가이드를 읽어보세요.',
    tutorialStep2Action: '가이드 보러가기',
    tutorialStep3Title: '내 정보 또는 랭킹 둘러보기',
    tutorialStep3Desc: '하단의 내 정보(프로필)나 랭킹 페이지를 눌러 정보를 탐색해보세요.',
    tutorialStep3Action: '운동 기록하기',
    recommendedMapTitle: '오늘 추천 작전: {mapName}',
    recommendedMapGuideActive: '오늘 추천 대륙의 작전을 클리어하셨군요! 훌륭합니다.',
    recommendedMapGuideInactive: '하단의 [맵] 탭을 눌러 이 대륙의 훈련들을 정벌하십시오!',
    
    // Home CTAs & Quests
    startTraining: '지옥 훈련 개시',
    questOperations: '수행 중인 작전 (퀘스트)',
    dailyQuest: '일일 퀘스트',
    weeklyQuest: '주간 퀘스트',
    monthlyQuest: '월간 퀘스트',
    weeklyTrainingChart: '주간 훈련 기록',
    emptyQuests: '지옥의 일일 퀘스트가 모두 완료되었거나 아직 하달되지 않았습니다.',
    emptyQuestsWeekly: '주간 퀘스트가 아직 하달되지 않았습니다.',
    emptyQuestsMonthly: '월간 퀘스트가 아직 하달되지 않았습니다.',
    activeQuestsCount: '진행 중인 퀘스트 ({count})',
    completedQuestsCount: '완료된 퀘스트 ({count})',
    claimReward: '보상 받기',
    allQuestsCompleted: '오늘의 모든 퀘스트 완료! 훌륭합니다.',
    viewDetail: '상세 보기',
    bodySegmentLevels: '부위별 전투력 (레벨)',
    lockedBodyPartsTitle: '신체 부위별 상세 정보 잠금됨',
    lockedBodyPartsDesc: '첫 운동 세트의 기록이 성공적으로 등록되면 각 부위별 세부 성장도 및 1RM 기록 장치가 활성화됩니다.',
    noSegmentLevels: '시스템 오프라인: 감지된 신체 부위 레벨 없음',
    
    // Settings Link Cards
    myCollection: '내 컬렉션',
    myCollectionDesc: '수집한 파편 확인 및 코어 융합',
    growthStats: '상세 성장 통계',
    growthStatsDesc: '운동 데이터 및 신체 통계 분석',
    gradeSystem: '등급 시스템',
    gradeSystemDesc: '전투력 랭킹 산정 공식 가이드',
    
    // Workout Record Page
    workoutRecord: '운동 기록',
    trainerFeed: '트레이너 피드',
    gorillaTouchGuide: '터치하여 부위 선택',
    touchBodyPartGuide: '운동할 부위를 터치하세요!',
    questStep: '퀘스트 단계',
    trainingCommand: '지옥의 트레이닝 지령',
    otherPart: '다른 부위 선택하기',
    selectedPart: '선택한 부위',
    changePart: '부위 변경',
    
    // Workout record sheets
    pastSession: '이전 기록',
    questScript: '내 루틴',
    hellAcademy: '전문화',
    pastSessionSubtitle: '이전 기록',
    questScriptSubtitle: '루틴 리스트',
    hellAcademySubtitle: '프로그램',
    
    // Yesterday Sheet
    yesterdayWorkout: '이전 운동',
    yesterdayWorkoutSummary: '총 {count}개 운동',
    syncingRecords: '기록 동기화 중...',
    noYesterdayRecord: '기록된 운동이 없네요',
    noYesterdayRecordSub: '첫 운동을 기록하고 역사를 만들어보세요',
    
    // Routine Sheet
    workoutRoutine: '워크아웃 루틴',
    syncingRoutines: '루틴 불러오는 중...',
    noRoutine: '저장된 루틴이 없습니다',
    noRoutineSub: '나만의 반복 훈련 세트를 구성해보세요',
    newRoutineBtn: '새 루틴 생성',
    startRoutineBtn: '루틴 시작하기',
    designNewRoutine: '새로운 루틴 설계하기',
    exerciseCountText: '{count}개 운동',
    completedCountText: '{count}회 완료',
    moreExercises: '+ {count}개 더보기',
    
    // Exercise list sheet
    searchExercise: '운동 검색...',
    recommendSort: '추천순',
    recentSort: '최근 운동순',
    difficultySort: '난이도순',
    alphabeticalSort: '가나다순',
    noExercises: '운동이 없습니다.',
    levelBeginner: 'LV.{score} 초급',
    levelIntermediate: 'LV.{score} 중급',
    levelAdvanced: 'LV.{score} 고급',
    bodyweightLabel: '맨몸',
    prevRecordLabel: '이전 기록',
    noPrevRecordLabel: '기록 없음',
    realtimeAnalysis: '실시간 세션 대비 분석',
    weightLabel: '무게 (kg)',
    repsLabel: '횟수',
    setsLabel: '세트',
    saveRecordBtn: '기록 저장하기',
    savingRecord: '저장 중...',
    
    // RM Block Modal
    rmBlockTitle: '1RM 초과 감지',
    rmBlockDesc: '현재 공인 1RM을 초과하는 기록입니다.',
    certifiedRM: '공인 1RM',
    estimatedRM: '추정 1RM',
    allowedLimit: '허용 한계 (105%)',
    rmBlockFooter: '레벨 테스트를 통해 공인 1RM을 갱신하면 이 무게로 기록할 수 있습니다.',
    closeBtn: '닫기',
    startLevelTestBtn: '레벨 테스트 시작',
    
    // Settings Page
    settingsTitle: '설정',
    settingsProfileEdit: '프로필 편집',
    settingsLevelTestResult: '등급 테스트 결과',
    settingsPrograms: '프로그램 둘러보기',
    settingsCustomExercises: '커스텀 운동 관리',
    settingsDataTransfer: '데이터 관리',
    settingsCommunity: '커뮤니티 / 게시판',
    settingsNotifications: '알림 설정',
    settingsSecurity: '개인정보 및 보안',
    settingsHelp: '도움말',
    settingsLanguage: '언어 설정 (Language)',
    settingsLogout: '로그아웃',
    settingsLogoutConfirm: '로그아웃 하시겠습니까?',
    activeProgram: '활성화된 프로그램',
    levelTestRequired: '테스트 필요',
    initialGradeText: '초기 등급: {grade}',
    myProgramSubtext: '새로운 커리큘럼 찾기',
    customExerciseSubtext: '나만의 운동 종목 추가/수정',
    dataTransferSubtext: '운동 기록 가져오기/내보내기',
    communitySubtext: '다른 유저들과 소통하기',
    notificationSubtext: '푸시 알림 관리',
    securitySubtext: '비밀번호, 계정 보안',
    helpSubtext: 'FAQ, 문의하기',
    
    // Design Skin Settings & Themes
    settingsTheme: '디자인 스킨 설정',
    settingsThemeSub: '훈련소의 메인 인터페이스 스킨을 변경합니다.',
    themeSelectorTitle: '디자인 스킨 선택',
    themeSelectorDesc: '훈련소 인터페이스 스킨을 변경합니다.',
    themeHell: '지옥 시그니처',
    themeHellDesc: '헬게이터 시그니처 화염 레드 테마',
    themeAmoled: 'AMOLED 블랙',
    themeAmoledDesc: '배터리를 절약하는 순수 블랙과 레드',
    themeMidnight: '미드나잇 민트',
    themeMidnightDesc: '차분한 블루블랙과 상큼한 민트',
    themeNavy: '딥 네이비',
    themeNavyDesc: '집중력을 높여주는 차분한 네이비 블루',
    themeWarm: '웜 다크',
    themeWarmDesc: '눈의 피로를 덜어주는 부드러운 브라운 다크',
    themeLight: '라이트 모드',
    themeLightDesc: '밝고 선명한 고대비 화이트 테마',
    themePurple: '네온 퍼플',
    themePurpleDesc: '사이버펑크 게이밍 감성의 보라색 테마',

    // Workout Success & Baalzebub Coach
    workoutSuccessTitle: '훈련 성공',
    prBreakthroughTitle: '🔥 1RM 한계 돌파! 🔥',
    comboText: '{count}연속 운동!',
    continueBtn: '계속하기',
    baalSpeechPR1: '이게 진정 필멸자의 힘인가?! 네 녀석, 기어코 한계를 쳐부쉈구나!!',
    baalSpeechPR2: '보아라! 지옥의 화염도 네 무거운 쇠질 앞에서는 사그라드는구나!',
    baalSpeechPR3: '크하하하! 대단하다! 그 기세로 지옥의 문도 뜯어내 버려라!',
    baalSpeechReg1: '닭가슴살만 씹지 말고 덤벨도 씹어삼켜라! 오늘 아주 훌륭했다!',
    baalSpeechReg2: '땀은 거짓말을 하지 않는다! 내일은 1kg이라도 더 얹는 거다!',
    baalSpeechReg3: '쇠질을 쉴 생각을 하다니, 지옥의 유황불 맛이 그리운 게냐?! 잘 마쳤다!',
    
    // Gym Rank Widget
    gymRankingMatch: '지옥의 헬스장 랭킹전',
    gymRankingMatchDesc: '등록하면 헬스장 내 실시간 순위가 노출됩니다',
    activeOnFirstWorkout: '첫 운동 기록 완료 시 활성화',
    registerGym: '헬스장 등록하기',
    registerGymDesc: '등록하면 같은 헬스장 회원끼리 랭킹을 겨룰 수 있어요',
    gymMembersCount: '회원 {count}명',
    viewLeaderboard: '랭킹 보기',
    
    // Physical Stats
    physicalAbilities: '신체 능력',
    strength: '근력',
    strengthDesc: '웨이트 트레이닝 등 강한 힘을 내는 근력 운동(스쿼트, 데드리프트 등) 완료 시 획득합니다.',
    endurance: '지구력',
    enduranceDesc: '러닝, 사이클, 맨몸운동 등 장시간 지속하는 근지구력 및 유산소 운동 완료 시 획득합니다.',
    agility: '민첩',
    agilityDesc: '버피, 점프 등 빠르고 폭발적인 순발력을 요하는 전신 운동 완료 시 획득합니다.',
    flexibility: '유연성',
    flexibilityDesc: '요가, 스트레칭 등 관절의 가동 범위를 넓히는 운동 완료 시 획득합니다.',
  },
  en: {
    // Header & HUD
    secureProtocol: 'SECURE PROTOCOL ACTIVE',
    sysOnline: 'SYS_ONLINE',
    
    // Tabs
    tabBase: 'Base Operations',
    tabCombat: 'Combat Power',
    tabUnion: 'Affiliation',
    
    // Hero
    level: 'LEVEL',
    todayWorkout: 'TODAY WORKOUT',
    streakDays: 'STREAK DAYS',
    questCompleted: 'QUEST COMPLETED',
    sets: 'SETS',
    days: 'DAYS',
    
    // Onboarding / Tutorial
    tutorialTitle: 'Beginner Guide Quests (Tutorial)',
    tutorialSubtitle: 'FTUE_BASIC_TRAINING_PROTOCOL',
    onboardingDesc: 'Welcome to the Hell Training Camp! Complete basic quests for new recruits to unlock all security locks and start true growth.',
    missionComplete: 'Mission Complete',
    tutorialStep1Title: 'Record First Workout Set',
    tutorialStep1Desc: 'Tap the [+] button on the bottom floating bar and record your actual workout.',
    tutorialStep2Title: 'Check Combat Power Guide',
    tutorialStep2Desc: 'Check the Grade System guide in the Settings menu.',
    tutorialStep2Action: 'View Guide',
    tutorialStep3Title: 'Explore Profile or Leaderboard',
    tutorialStep3Desc: 'Tap the Profile or Leaderboard in the navigation bar to explore.',
    tutorialStep3Action: 'Record Workout',
    recommendedMapTitle: 'Today\'s Recommended Operation: {mapName}',
    recommendedMapGuideActive: 'You have cleared the mission in today\'s recommended continent! Excellent.',
    recommendedMapGuideInactive: 'Tap the [MAP] tab at the bottom to conquer training in this continent!',
    
    // Home CTAs & Quests
    startTraining: 'START TRAINING',
    questOperations: 'QUEST OPERATIONS',
    dailyQuest: 'Daily Quests',
    weeklyQuest: 'Weekly Quests',
    monthlyQuest: 'Monthly Quests',
    weeklyTrainingChart: 'Weekly Training Log',
    emptyQuests: 'All daily quests are completed or not assigned yet.',
    emptyQuestsWeekly: 'Weekly quests are not assigned yet.',
    emptyQuestsMonthly: 'Monthly quests are not assigned yet.',
    activeQuestsCount: 'Active Quests ({count})',
    completedQuestsCount: 'Completed Quests ({count})',
    claimReward: 'Claim Reward',
    allQuestsCompleted: 'All quests completed! Great job.',
    viewDetail: 'VIEW DETAIL',
    bodySegmentLevels: 'BODY SEGMENT LEVELS',
    lockedBodyPartsTitle: 'Detailed Body Part Info Locked',
    lockedBodyPartsDesc: 'Detailed growth rate and 1RM records will unlock once your first workout set is logged successfully.',
    noSegmentLevels: 'SYSTEM OFFLINE: NO SEGMENT LEVELS DETECTED',
    
    // Settings Link Cards
    myCollection: 'My Collection',
    myCollectionDesc: 'Check collected fragments and core fusion',
    growthStats: 'Detailed Growth Stats',
    growthStatsDesc: 'Analyze workout data and body stats',
    gradeSystem: 'Grade System',
    gradeSystemDesc: 'Combat power ranking formulas guide',
    
    // Workout Record Page
    workoutRecord: 'Workout Record',
    trainerFeed: 'Trainer Feed',
    gorillaTouchGuide: 'Touch to select body part',
    touchBodyPartGuide: 'Touch the body part to train!',
    questStep: 'QUEST STEP',
    trainingCommand: 'Hell Training Directive',
    otherPart: 'Select Other Body Part',
    selectedPart: 'Selected Part',
    changePart: 'Change Part',
    
    // Workout record sheets
    pastSession: 'PAST SESSION',
    questScript: 'QUEST SCRIPT',
    hellAcademy: 'HELL ACADEMY',
    pastSessionSubtitle: 'Yesterday Record',
    questScriptSubtitle: 'Routine List',
    hellAcademySubtitle: 'Program',
    
    // Yesterday Sheet
    yesterdayWorkout: 'Previous Workout',
    yesterdayWorkoutSummary: 'Total {count} Exercises',
    syncingRecords: 'Syncing records...',
    noYesterdayRecord: 'No workouts recorded yet',
    noYesterdayRecordSub: 'Record your first workout and make history',
    
    // Routine Sheet
    workoutRoutine: 'Workout Routine',
    syncingRoutines: 'Loading routines...',
    noRoutine: 'No routines saved',
    noRoutineSub: 'Configure your own repeat training sets',
    newRoutineBtn: 'Create New Routine',
    startRoutineBtn: 'Start Routine',
    designNewRoutine: 'Design New Routine',
    exerciseCountText: '{count} Exercises',
    completedCountText: '{count} times completed',
    moreExercises: '+ {count} more',
    
    // Exercise list sheet
    searchExercise: 'Search exercise...',
    recommendSort: 'Recommend',
    recentSort: 'Recent',
    difficultySort: 'Difficulty',
    alphabeticalSort: 'A-Z',
    noExercises: 'No exercises found.',
    levelBeginner: 'LV.{score} Beginner',
    levelIntermediate: 'LV.{score} Intermediate',
    levelAdvanced: 'LV.{score} Advanced',
    bodyweightLabel: 'Bodyweight',
    prevRecordLabel: 'Previous Record',
    noPrevRecordLabel: 'No Record',
    realtimeAnalysis: 'Real-time Session Analysis',
    weightLabel: 'Weight (kg)',
    repsLabel: 'Reps',
    setsLabel: 'Sets',
    saveRecordBtn: 'Save Record',
    savingRecord: 'Saving...',
    
    // RM Block Modal
    rmBlockTitle: '1RM Limit Detected',
    rmBlockDesc: 'This record exceeds your current certified 1RM.',
    certifiedRM: 'Certified 1RM',
    estimatedRM: 'Estimated 1RM',
    allowedLimit: 'Allowed Limit (105%)',
    rmBlockFooter: 'Perform a Level Test to update your certified 1RM and log this weight.',
    closeBtn: 'Close',
    startLevelTestBtn: 'Start Level Test',
    
    // Settings Page
    settingsTitle: 'Settings',
    settingsProfileEdit: 'Edit Profile',
    settingsLevelTestResult: 'Grade Test Results',
    settingsPrograms: 'Browse Programs',
    settingsCustomExercises: 'Manage Custom Exercises',
    settingsDataTransfer: 'Data Management',
    settingsCommunity: 'Community Boards',
    settingsNotifications: 'Notifications',
    settingsSecurity: 'Privacy & Security',
    settingsHelp: 'Help',
    settingsLanguage: 'Language Settings',
    settingsLogout: 'Logout',
    settingsLogoutConfirm: 'Are you sure you want to log out?',
    activeProgram: 'Active Program',
    levelTestRequired: 'Test Required',
    initialGradeText: 'Initial Grade: {grade}',
    myProgramSubtext: 'Find new curriculum',
    customExerciseSubtext: 'Add/edit your own exercises',
    dataTransferSubtext: 'Import/Export workout records',
    communitySubtext: 'Communicate with other users',
    notificationSubtext: 'Manage push notifications',
    securitySubtext: 'Password & account security',
    helpSubtext: 'FAQ, Contact us',
    
    // Design Skin Settings & Themes
    settingsTheme: 'Design Theme',
    settingsThemeSub: 'Change the interface skin of the camp.',
    themeSelectorTitle: 'Select Design Theme',
    themeSelectorDesc: 'Change the camp interface theme.',
    themeHell: 'Hell Signature',
    themeHellDesc: 'Hellgater signature fiery red theme',
    themeAmoled: 'AMOLED Black',
    themeAmoledDesc: 'Pure black and red to save battery',
    themeMidnight: 'Midnight Mint',
    themeMidnightDesc: 'Calm blue-black with fresh mint',
    themeNavy: 'Deep Navy',
    themeNavyDesc: 'Calm navy blue to increase focus',
    themeWarm: 'Warm Dark',
    themeWarmDesc: 'Soft brown dark to reduce eye strain',
    themeLight: 'Light Mode',
    themeLightDesc: 'Bright and clear high-contrast white theme',
    themePurple: 'Neon Purple',
    themePurpleDesc: 'Cyberpunk gaming vibe purple theme',

    // Workout Success & Baalzebub Coach
    workoutSuccessTitle: 'Training Success',
    prBreakthroughTitle: '🔥 1RM Limit Shattered! 🔥',
    comboText: '{count} Workout Streak!',
    continueBtn: 'Continue',
    baalSpeechPR1: 'Is this truly the strength of a mortal?! You have finally crushed your limit!!',
    baalSpeechPR2: 'Behold! Even the fires of hell wither before your heavy iron!',
    baalSpeechPR3: 'Mwahaha! Magnificent! With that momentum, tear down the gates of hell itself!',
    baalSpeechReg1: 'Don\'t just chew chicken breast, chew and swallow the dumbbells! Excellent job today!',
    baalSpeechReg2: 'Sweat never lies! Tomorrow, add at least 1kg more!',
    baalSpeechReg3: 'Thinking of resting from iron? Do you miss the sulfur fires of hell?! Well done!',
    
    // Gym Rank Widget
    gymRankingMatch: 'Hell Gym Ranking Match',
    gymRankingMatchDesc: 'Register to display real-time ranks in your gym.',
    activeOnFirstWorkout: 'Unlocks on first workout completion',
    registerGym: 'Register Gym',
    registerGymDesc: 'Register to compete with other members at your gym.',
    gymMembersCount: '{count} Members',
    viewLeaderboard: 'Leaderboard',
    
    // Physical Stats
    physicalAbilities: 'Physical Abilities',
    strength: 'Strength',
    strengthDesc: 'Earned by completing strength training (Squat, Deadlift, etc.).',
    endurance: 'Endurance',
    enduranceDesc: 'Earned by completing endurance or aerobic exercise (Running, Cycling, Bodyweight, etc.).',
    agility: 'Agility',
    agilityDesc: 'Earned by completing explosive full-body workouts (Burpees, Jumps, etc.).',
    flexibility: 'Flexibility',
    flexibilityDesc: 'Earned by completing workouts that increase joint range of motion (Yoga, Stretching, etc.).',
  }
};

export type Language = 'ko' | 'en';

interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string, variables?: Record<string, string | number>) => string;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

const LANGUAGE_STORAGE_KEY = 'hellgater-language';

export function LanguageProvider({ children }: { children: ReactNode }) {
  const [language, setLanguageState] = useState<Language>(() => {
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem(LANGUAGE_STORAGE_KEY);
      if (saved === 'en' || saved === 'ko') {
        return saved;
      }
    }
    return 'ko'; // Default to Korean
  });

  const setLanguage = (lang: Language) => {
    setLanguageState(lang);
    localStorage.setItem(LANGUAGE_STORAGE_KEY, lang);
  };

  const t = (key: string, variables?: Record<string, string | number>) => {
    const langTrans = translations[language] || translations['ko'];
    let text = langTrans[key] || translations['ko'][key] || key;
    
    if (variables) {
      Object.entries(variables).forEach(([k, v]) => {
        text = text.replace(`{${k}}`, String(v));
      });
    }
    return text;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
